'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import { useAuth } from '@/contexts/AuthContext';
import LoginModal from './LoginModal';

export default function LoginButton() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { user } = useAuth();

  // Only show if user is not logged in
  if (user) return null;

  return (
    <>
      <button data-component-id="src/app/homepage/components/LoginButton.tsx:17:6" data-component-path="src/app/homepage/components/LoginButton.tsx" data-component-line="17" data-component-end-line="23" data-component-file="LoginButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-6%20right-6%20z-40%20w-14%20h-14%20bg-primary%20text-primary-foreground%20rounded-full%20shadow-lg%20hover%3Ashadow-xl%20hover%3Ascale-110%20transition-all%20duration-300%20flex%20items-center%20justify-center%20touch-manipulation%20active%3Ascale-95%22%7D"
        onClick={() => setIsLoginModalOpen(true)}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 flex items-center justify-center touch-manipulation active:scale-95"
        aria-label="Login"
      >
        <Icon data-component-id="src/app/homepage/components/LoginButton.tsx:22:8" data-component-path="src/app/homepage/components/LoginButton.tsx" data-component-line="22" data-component-end-line="22" data-component-file="LoginButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22UserCircleIcon%22%2C%22className%22%3A%22text-primary-foreground%22%7D" name="UserCircleIcon" size={28} className="text-primary-foreground" />
      </button>

      <LoginModal data-component-id="src/app/homepage/components/LoginButton.tsx:25:6" data-component-path="src/app/homepage/components/LoginButton.tsx" data-component-line="25" data-component-end-line="25" data-component-file="LoginButton.tsx" data-component-name="LoginModal" data-component-content="%7B%22elementName%22%3A%22LoginModal%22%7D" isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </>
  );
}